import {
  type InventoryAndContentState,
  InventoryContentOption,
  TargetableInventoryOption,
} from '@openx/types/targeting/inventoryAndContent';

export const getSelectedOptionsCount = (targetingParams: InventoryAndContentState | null) => {
  let result = 0;

  if (!targetingParams) return result;

  if (targetingParams.account.val.length > 0) result++;
  if (targetingParams[InventoryContentOption.ADUNIT].val.length > 0) result++;
  if (targetingParams[InventoryContentOption.ADUNIT_SIZE].val.length > 0) result++;
  if (targetingParams[InventoryContentOption.INSTANCE_HASH].val.length > 0) result++;
  if (
    targetingParams[InventoryContentOption.INVENTORY][TargetableInventoryOption.INCLUDES].length > 0 ||
    targetingParams[InventoryContentOption.INVENTORY][TargetableInventoryOption.EXCLUDES].length > 0
  )
    result++;
  if (targetingParams[InventoryContentOption.KEYWORDS].val.length > 0) result++;
  if (targetingParams[InventoryContentOption.LINE_ITEM_APP_BUNDLE_ID].val.length > 0) result++;
  if (targetingParams[InventoryContentOption.SITE].val.length > 0) result++;
  if (Object.keys(targetingParams[InventoryContentOption.PAGE_URL].val || {}).length > 0) result++;
  if (
    Object.keys(targetingParams[InventoryContentOption.APP_BUNDLE_ID].val || {}).length > 0 ||
    targetingParams[InventoryContentOption.APP_BUNDLE_ID].inventorylist_id !== ''
  )
    result++;
  if (Object.keys(targetingParams[InventoryContentOption.APP_GROUP]?.val || {}).length > 0) result++;

  return result;
};
